import { TextField, TextFieldProps } from '@mui/material'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { memo } from 'react'
import { ReactMaskOpts } from 'react-imask'
import { MaskedInput } from '../masked-input'

export type TextInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<TextFieldProps, 'name'> & {
  name: TName
  control: Control<TFieldValues>
  mask?: string | ReactMaskOpts
  format?: 'currency' | 'percentage'
}

const TextInputComponent = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  mask,
  format,
  ...props
}: TextInputProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        if (mask || format) {
          return (
            <MaskedInput
              mask={mask}
              format={format}
              error={!!error}
              helperText={error?.message || props.helperText}
              {...field}
              {...props}
            />
          )
        }

        return (
          <TextField
            {...field}
            {...props}
            error={!!error}
            helperText={error?.message || props.helperText}
          />
        )
      }}
    />
  )
}

export const TextInput = memo(TextInputComponent) as typeof TextInputComponent
